<script context="module">
    import { env } from '../Environment.svelte';

    export async function getStores(latitude, longitude) {
        var STORES_ENDPOINT =
            env[env.stage].api.url +
            'apikey/izzi/ms/purchaseServices/autoinstalacion/availableStores';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);

        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                latitude: latitude,
                longitude: longitude,
            }),
        };

        const response = fetch(STORES_ENDPOINT, requestOptions)
            .then((response) => response.json())
            .then((result) => result);
        return await response;
    }

    export async function getStock() {
        var STOCK_ENDPOINT =
            env[env.stage].apiAutoInstall.url +
            'apikey/sandbox/v1/inventory/getExistenciaSap';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].apiStore.key);
        headers.append('Cookie', env[env.stage].apiStore.cookie);
        try {
            let requestOptions = {
                method: 'POST',
                headers: headers,
                redirect: 'follow',
                body: JSON.stringify({
                    sku: env[env.stage].apiStore.sku,
                }),
            };
            const response = await fetch(STOCK_ENDPOINT, requestOptions);

            if (!response.ok) {
                throw new Error(
                    `Error fetching stock: ${response.status} ${response.statusText}`
                );
            }

            const allStores = await response.json();
            return allStores;
        } catch (error) {
            console.error('Error fetching stock:', error);
            return 'Error fetching stock';
        }
    }
</script>
